import React from 'react';

import { Ctn, Track, Slider } from './index.style';

/**
 * The waiting indicator for screens that have not been moved to the single top line yet (ApiStatus draws it). A sliding
 * line shows that something is happening. It does NOT show a percentage - the calls behind these screens report no
 * progress, and a bar filling on a timer would be a made-up figure - and it shows NO SECONDS and no note about how long
 * the wait may be: both were tried and removed (Robert, 21 Oct 2026) because they draw attention to how slow it is.
 */

interface LoadingProgressProps {
  // 'ring' is the full-page version; 'bar' sits inside a section.
  size?: 'ring' | 'bar';
}

const LoadingProgress: React.FC<LoadingProgressProps> = ({ size = 'bar' }): React.ReactElement => {
  return (
    <Ctn large={size === 'ring'} role="status" aria-live="polite" aria-label="Loading">
      <Track><Slider /></Track>
    </Ctn>
  );
};

export default LoadingProgress;
